import { getDateFromEpoch } from 'constants/helper';

export default class Organization {
  constructor() {
    this.id = '';
    this.orgName = '';
    this.logoUrl = '';
    this.logoutUrl = null;
    this.applauseRefillFrequency = '';
    this.meshMoneyToINRExchangeRate = 0.0;
    this.sharedMeshMoney = 0;
    this.createdDate = '';
    this.updatedDate = '';
    this.isEnterpriseOrg = '';
    this.checkinFrequency = '';
    this.timezoneOffsetDiff = '';
    this.planType = '';
    this.country = '';
    this.currency = '';
    this.language = '';
    this.defaultTimezoneOffsetDiff = '';
    this.organizationStatus = '';
    this.startMonth = '';
    this.displayNameConfig = '';
    this.timezone = '';
    this.employeeUniqueKey = '';
  }

  fromJSON = (res = {}) => {
    this.id = res.uuid;
    this.orgName = res.orgName;
    this.logoUrl = res.logoUrl;
    this.logoutUrl = res.logoutUrl;
    this.applauseRefillFrequency = res.applauseRefillFrequency;
    this.meshMoneyToINRExchangeRate = res.meshMoneyToINRExchangeRate;
    this.sharedMeshMoney = res.sharedMeshMoney;
    this.createdDate = getDateFromEpoch(res.createdTS);
    this.updatedDate = getDateFromEpoch(res.updatedTS);
    this.isEnterpriseOrg = res.isEnterpriseOrg;
    this.checkinFrequency = res.checkinFrequency;
    this.timezoneOffsetDiff = res.timezoneOffsetDiff;
    this.planType = res.planType;
    this.country = res.country;
    this.currency = res.currency;
    this.language = res.language;
    this.defaultTimezoneOffsetDiff = res.defaultTimezoneOffsetDiff;
    this.organizationStatus = res.organizationStatus;
    this.startMonth = res.startMonth;
    this.displayNameConfig = res.displayNameConfig;
    this.timezone = res.timezone;
    this.employeeUniqueKey = res.employeeUniqueKey;
  };
}
